import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getRecyclingProcessCountQuery: DocumentNode = gql`
  query GetRecyclingProcessCount($startDate: DateTime!, $endDate: DateTime!, $hideInactiveProcesses: Boolean!, $searchInput: String!) {
    recyclingProcessCount(startDate: $startDate, endDate: $endDate, hideInactiveProcesses: $hideInactiveProcesses, searchInput: $searchInput)
  }
`;
